<template>
    <div class="addressBook">
        <header>
            <h2>Addresses</h2>
            <address-book-list :selectedDN="selectedDN" :scopes="scopes" @click="selectBook"
            @selectDN="selectEntry"></address-book-list>
        </header>
        <div class="search">
            <address-search v-model="searchText"></address-search>
        </div>
        <article class="addressGrid" :class="{ showEntry: showEntry && !!entry }">
            <address-book-entries :selectedDN="selectedDN" :scopes="scopes"
                    :searchText="searchText" @select="selectEntry"></address-book-entries>
            <div class="entryViewWrap">
                <address-entry-view class="entryView" v-if="entry" :dn="entryDN" :entry="entry" :scopes="scopes"
                        @hide="hideEntry"></address-entry-view>
            </div>
        </article>
    </div>
</template>

<script>
import AddressBookList from '@/components/addressBookList';
import AddressBookEntries from '@/components/addressBookEntries';
import AddressSearch from '@/components/addressSearch';
import AddressEntryView from '@/components/addressEntryView';

export default {
  name: 'addresses',
  components: { AddressBookList, AddressBookEntries, AddressSearch, AddressEntryView },
  data: function() {
    return {
      selectedDN2: 'o=vpop3',
      searchText: '',
      entryDN: null,
      showEntry: false
    };
  },
  mounted() {
  },
  methods: {
    selectBook(DN) {
      this.selectedDN = DN;
    },
    selectEntry(dn) {
      this.entryDN = dn;
      this.showEntry = true;
    },
    hideEntry() {
      this.showEntry = false;
    }
  },
  computed: {
    scopes() {
      let s = [{ id: -1, dn: 'o=collected', name: 'collected', standard: true }]
        .concat(this.$store.state.addressBookScopes)
        .map((s, ind) => {
          if (s.standard) {
            return Object.assign({}, s,
              { displayName: this.$t(`addressBook.standard.${s.name}`), index: ind });
          } else {
            if (s.owner.localeCompare(this.$store.state.username, 'en', { sensitivity: 'base' }) === 0) {
              return Object.assign({}, s, {
                displayName: this.$t('addressBook.personal', { owner: s.owner, name: s.name }),
                index: ind });
            } else {
              return Object.assign({}, s, {
                displayName: this.$t('addressBook.owned', { owner: s.owner, name: s.name }),
                index: ind });
            }
          }
        });

      s.sort((a, b) => {
        if ((a.standard) && (b.standard)) {
          return a.index - b.index;
        } else if ((a.standard) && (!b.standard)) {
          return -1;
        } else if ((!a.standard) && (b.standard)) {
          return 1;
        } else {
          let aOwner = a.owner;
          let bOwner = b.owner;
          if (aOwner.localeCompare(this.$store.state.username, undefined, { sensitivity: 'base' }) === 0) {
            aOwner = '';
          }
          if (bOwner.localeCompare(this.$store.state.username, undefined, { sensitivity: 'base' }) === 0) {
            bOwner = '';
          }
          if (aOwner !== bOwner) {
            return aOwner.localeCompare(bOwner, undefined, { sensitivity: 'base' });
          } else {
            return a.name.localeCompare(b.name, undefined, { sensitivity: 'accent' });
          }
        }
      });
      console.log('sorted', s);

      return s;
    },
    selectedDN() {
      let scope = null;
      console.log('calc selectedDN', this.$route.name, this.$route.params);
      if (this.$route.name === 'addressBook') {
        scope = this.scopes.find(s => s.name === this.$route.params.book);
      } else {
        scope = this.scopes.find(s => (s.name === this.$route.params.folder) && (s.owner === this.$route.params.owner));
      }
      if (scope) {
        return scope.dn;
      } else {
        return '';
      }
    },
    entry() {
      if (this.entryDN) {
        const e = this.$store.state.addressBookEntries[this.entryDN];
        return e;
      } else {
        return null;
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .addressBook {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;

        header {
            flex: 0 auto;
        }
        .search {
            flex: 0 auto;
        }
        article {
            flex: 1;
            min-height: 0;
            display: grid;
            grid-template-columns: 1fr auto;
            position: relative;
            .entryViewWrap {
                transition: all 0.5s;
                width: 0;
                overflow: hidden;
                position: relative;
                .entryView {
                    width: 50vw;
                }
            }
            &.showEntry {
                .entryViewWrap {
                    width: 50vw;
                    box-shadow: 0 0 10px 3px $gray-400;
                }
                // grid-template-columns: 50% 50%; - when grid-template-column transitions are widely supported
            }
        }
    }
</style>
